// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client'; // Импорт createRoot из react-dom
import './index.css'; // Основные стили
import App from './App'; // Главный компонент приложения

// Получение корневого элемента для рендера приложения
const container = document.getElementById('root');
const root = createRoot(container); // Создаем root с помощью createRoot

// Рендерим приложение
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);